import React, {useState, useRef, useEffect} from 'react';
const $ = require('jquery');

const SearchBox = (props: any) => {
  const inputRef = useRef(null);
  let searchBox: any;

  const onPlacesChanged = ({map, addplace} = props) => {
    const selected = searchBox.getPlaces();
    // alert("HI");
    const {0: place} = selected;
    if (!place.geometry) return;
    if (place.geometry.viewport) {
      map.fitBounds(place.geometry.viewport);
    } else {
      map.setCenter(place.geometry.location);
      map.setZoom(17);
    }

    inputRef.current.blur();
    inputRef.current.value = '';
  };

  useEffect(() => {
    const input = inputRef.current;
    searchBox = new props.mapApi.places.SearchBox(inputRef.current);
    searchBox.addListener('places_changed', onPlacesChanged);
    searchBox.bindTo('bounds', props.map);
    return () => {
      props.mapApi.event.clearInstanceListeners(searchBox);
    };
  }, []);
  return (
    <input
      className="col-6"
      ref={inputRef}
      placeholder="กรอกชื่อสถานที่"
      type="text"
    />
  );
};

const Marker = (props: any) => {
  const [marker, setMarker] = useState();
  // const [data, setData] = useState<any>();

  const getInfoContent = (title) => {
    const id = title.substring(
      title.lastIndexOf('[') + 1,
      title.lastIndexOf(']')
    );
    return (
      '<div id="content">' +
      '<div id="siteNotice">' +
      '</div>' +
      '<h6 id="firstHeading" class="firstHeading">' +
      title +
      '</h6>' +
      '<div id="bodyContent" class="h-100 d-flex justify-content-start align-items-end">' +
      '<a target="_blank" href="https://api-passport.advanceagro.net/cdsapi/company_image/' +
      id +
      '"><img src="https://api-passport.advanceagro.net/cdsapi/company_image/' +
      id +
      '" style="width:100px;height:100px;"></a><button class="poi btn btn-primary ml-2" id="point_' +
      id +
      '" name="point" type="button" value="' +
      id +
      '">เพิ่มจุดแวะ</button>' +
      '</div>' +
      '</div>'
    );
  };

  useEffect(() => {
    if (!marker) {
      // setMarker(new google.maps.Marker());
      // var infoWindow = new google.maps.InfoWindow({
      //   maxWidth: 400
      // });
      var infoWindow = new google.maps.InfoWindow({
        maxWidth: 400
      });

      google.maps.event.addListener(infoWindow, 'domready', function () {
        $('.poi').click(function () {
          //Do your thing
          console.log(this.id);
          console.log(this.value);

          props.addByMap(this.value)
        });
      });

      var _marker = new google.maps.marker.AdvancedMarkerElement();
      _marker.addListener('click', (e) => {
        console.log(_marker.title);
        // console.log(data);

        var _info = getInfoContent(_marker.title);
        infoWindow.close();
        infoWindow.setContent(_info);
        infoWindow.open(_marker.map, _marker);
      });
      setMarker(_marker);
    }

    return () => {
      if (marker) {
        // marker.setMap(null);
        marker.map = null;
      }
    };
  }, [marker]);

  useEffect(() => {
    if (marker) {
      // let pin = new google.maps.marker.PinElementOptions({background: '#FBBC04'});
      let pin = new google.maps.marker.PinElement({
        background: '#008000',
        borderColor: '#023020',
        glyph: props.position.title ? props.position.title : null,
        glyphColor: 'white',
        scale: props.position.scale ? props.position.scale : 1
      });

      // marker.setOptions({
      //   position: props.position,
      //   map: props.map,
      // });

      marker.position = props.position;
      marker.map = props.map;
      marker.title = props.position.name ? props.position.name : '';
      if (props.position.color) {
        marker.content = pin.element;
      }

      // setData(props.position);
    }
  }, [marker, props]);

  return null;
};

const SelectedBox = (props: any) => {
  return (
    <div>
      {props.selected
        .filter((el) => el.selected === true)
        .map((e, i) => (
          <div className="col-md-12 mb-2" key={i}>
            <div className="input-group">
              <div className="input-group-prepend">
                <span className="input-group-text">{e.label}</span>
              </div>
              <input
                disabled={props.isDisabled}
                type="number"
                className="form-control"
                value={e.amount}
                // defaultValue={e.amount}
                onChange={(el) => {
                  props.onValueChange(e.value, el.target.value);
                }}
              />
              <div className="input-group-append">
                <span className="input-group-text">{e.unit}</span>
              </div>
            </div>
          </div>
        ))}
    </div>
  );
};
export {Marker, SearchBox, SelectedBox};
